t = require('app/scripts/views/internal/teacup-with-helpers')('list_bulk_card_move')

module.exports = ->
  t.form ->

    t.ul '.pop-over-list', ->
      t.mustacheBlock 'lists', ->
        t.li ->
          t.a { href: '#', class: 'js-select-list highlight-icon ' + t.mustacheBlock('current', (-> ' disabled')), name: t.mustacheVar('id') }, ->
            t.text t.mustacheVar('name')
            t.mustacheBlock 'current', ->
              t.text ' '
              t.format 'current'

